import { ScrollView, usePropsResolution } from 'native-base';
import React from 'react';
import { cloneElementWithProps } from '../../utils/component';

import type { ITabProps } from './Tab';
import type { ITabsProps } from './Tabs.types';

const Tabs = (
  { activeTab, children, onChange, ...props }: ITabsProps,
  ref: any
) => {
  const resolvedProps = usePropsResolution('Tabs', props);

  const tabs = React.useMemo(
    () =>
      cloneElementWithProps<ITabProps>(children, (childProps) => ({
        active: childProps.identifier === activeTab,
        onPress: () => {
          onChange(childProps.identifier);
        },
      })),
    [activeTab, children, onChange]
  );

  return (
    <ScrollView
      _contentContainerStyle={{ ...resolvedProps }}
      horizontal={true}
      ref={ref}
    >
      {tabs}
    </ScrollView>
  );
};

export default React.memo(React.forwardRef(Tabs));
